import axiosInstance from "@/axiosInstance";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const addRating = createAsyncThunk(
  "rating/addRating",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/website/reviews/add", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


const ratingSlice = createSlice({
  name: "rating",
  initialState: {
    rating: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRating.fulfilled, (state, action) => {
        state.loading = false;
        state.rating = action.payload;
      })
      .addCase(addRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }}
  );

  export default ratingSlice.reducer;